import type { Entitlement } from '../types/domain';

export const PACKAGE_KEYS = [
  'commercial',
  'studio',
  'composerPlus',
  'professional',
  'unlimited',
  'dfyVault',
  'reseller',
  'publisher',
] as const;
export type PackageKey = (typeof PACKAGE_KEYS)[number];
export const PACKAGE_LABELS: Record<PackageKey, string> = {
  commercial: 'Commercial License & Creator Toolkits',
  studio: 'Studio',
  composerPlus: 'Composer+',
  professional: 'Professional',
  unlimited: 'Unlimited Song Creation & Expanded Publisher Monetization',
  dfyVault: 'DFY Producer Vault',
  reseller: 'Reseller License',
  publisher: 'Publisher',
};
export function accessLevel(entitlements: Entitlement): number {
  return PACKAGE_KEYS.reduce((count, key) => count + Number(entitlements[key]), 0);
}
